import { Trans, useTranslation } from "react-i18next";
import { useParams, Link } from "react-router";

import { useGetEmailVerificationRequestSuspense, useVerifyEmailAddress } from "@/api/bale";
import { Button } from "@/components/Button";
import { Card, CardHeader, CardTitle } from "@/components/Card";
import { ContentFull, ContentLayout } from "@/components/ContentLayout";
import { ErrorDetail } from "@/components/ErrorDetail";
import { FullScreenLayout } from "@/components/FullScreenLayout";
import { Subtitle } from "@/components/Subtitle";
import { Success } from "@/components/Success";

export function VerifyEmailPage() {
  const params = useParams();
  const verificationId = params.verificationId!;
  const { t } = useTranslation();
  const verifyEmail = useVerifyEmailAddress();
  const emailVerificationRequest = useGetEmailVerificationRequestSuspense(verificationId, {
    query: { select: (data) => data.data.email_verification },
  });

  function handleSubmit() {
    verifyEmail.mutate({ verificationId });
  }

  return (
    <FullScreenLayout>
      <ContentLayout title={t("verify-email-title")} wet>
        <ContentFull>
          <div className="mt-26 flex flex-col">
            <Card>
              <CardHeader>
                <CardTitle>
                  <Subtitle>{t("verify-email-title")}</Subtitle>
                  <p className="font-interest">{emailVerificationRequest.data.email_address}</p>
                </CardTitle>
              </CardHeader>
              <div className="flex flex-col gap-8 p-4">
                {verifyEmail.isSuccess && (
                  <Success className="">
                    <Trans
                      i18nKey="verify-email-complete"
                      components={{
                        loginLink: (
                          <Link
                            className="text-[hsl(from_currentcolor_h_s_calc((l+75)/2))] underline hover:text-[hsl(from_currentcolor_h_s_calc((l+50)/2))]"
                            to="/join"
                            state={{ showingForm: "login" }}
                          />
                        ),
                      }}
                    />
                  </Success>
                )}
                {!verifyEmail.isSuccess && !verifyEmail.isError && (
                  <>
                    <div className="flex flex-col gap-2 font-disinterest">
                      <Trans
                        i18nKey="verify-email-disclaimer"
                        values={{
                          email: emailVerificationRequest.data.email_address,
                        }}
                      />
                    </div>
                    <Button type="button" onClick={handleSubmit} disabled={verifyEmail.isPending}>
                      {t("verify")}
                    </Button>
                  </>
                )}
                {verifyEmail.isError && (
                  <div className="rounded-md border border-red-200 bg-red-50 p-4 font-disinterest text-red-700">
                    <ErrorDetail error={verifyEmail.error?.info} />
                  </div>
                )}
              </div>
            </Card>
          </div>
        </ContentFull>
      </ContentLayout>
    </FullScreenLayout>
  );
}
